import { service } from ".";

export default {
  getAll: () => service.get("/projectCategories"),
  getOne: (id) => service.get(`/projectCategories/${id}`),
  getAllPaginate: (query) =>
    service.get(`/projectCategories/paginate?${query}`),
  create: (data) => service.post("/projectCategories", data),
  update: (id, data) => service.put(`/projectCategories/${id}`, data),
  delete: (id) => service.delete(`/projectCategories/${id}`),
};
